import React from 'react';
import { ThemedText, ThemedView } from '@app/theme';
import { Platform, TouchableOpacity, ActivityIndicator, StyleSheet, Dimensions } from 'react-native';
import Button from '@app/sharedComponents/Button/Button';
import { DefaultRTA } from '@app/types';
import { trackEvent } from '@app/utils';
const screenWidth = Dimensions.get('window').width;
const panCardRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

type FooterProps = {
    defaultRTA: DefaultRTA | undefined;
    rtaDetailsFetching: boolean;
    onEditRTA: () => void;
    onFetchPortfolio: () => void;
    buttonLoader: boolean;
    routeName: string;
    retryingFetchPortfolio?: boolean;
    panNumber: string | null;
    mobileNumber: string | null;
    showEditablePanFlow: boolean;
    panEditable: boolean;
};

const Footer: React.FC<FooterProps> = ({
    defaultRTA,
    rtaDetailsFetching,
    onEditRTA,
    onFetchPortfolio,
    buttonLoader,
    routeName,
    retryingFetchPortfolio,
    panNumber,
    mobileNumber,
    showEditablePanFlow,
    panEditable
}) => {
    return (
        <>
            <ThemedView
                backgroundColor='bg-fill-primary'
                style={[Platform.OS === 'web' ? ls.webBtn : ls.nativeBtn]}
                borderTopWidth={1}
                borderTopColor='border-primary'
            >
                <ThemedView m="lg">
                    <Button
                        eventName={'CHECK_LIMIT_PAGE_CTA'}
                        additionalProperties={{
                            source: 'MF_FETCH_PORTFOLIO',
                            rtaName: defaultRTA?.repositoryName
                        }}
                        label={!panEditable ? 'Get my portfolio' : 'Check eligibility'}
                        handlePress={() => {
                            onFetchPortfolio()
                        }}
                        type={'SOLID'}
                        size='MD'
                        bg='bg-primary'
                        textColor='text-primary'
                        disabled={panNumber && mobileNumber && mobileNumber.length === 10 && panCardRegex.test(panNumber) ? false : true}
                        buttonLoader={buttonLoader}
                    />
                </ThemedView>
                {
                    !retryingFetchPortfolio &&
                    <ThemedView flexDirection='row' alignItems='center' justifyContent='center' style={{ marginBottom: 16 }}>
                    <ThemedText variant='b4r' color='text-secondary' fontWeight='400'>
                        Getting portfolio from {' '}
                    </ThemedText>
                        {rtaDetailsFetching ? (
                            <ActivityIndicator size='small' color='blue' />
                        ) : (
                            <>
                                <ThemedText variant='b4s' color='text-primary' fontWeight='600'>
                                    {defaultRTA?.repositoryName} {' '}
                                </ThemedText>
                                <TouchableOpacity onPress={() => {
                                    onEditRTA()
                                    trackEvent('EDIT_PORTFOLIO_SOURCE_CLICKED', {
                                        source: 'MF_FETCH_PORTFOLIO',
                                        rtaName: defaultRTA?.repositoryName
                                    })
                                }}>
                                    <ThemedText variant='b4r' color='text-action-primary' fontWeight='700'>
                                        Edit
                                    </ThemedText>
                                </TouchableOpacity>
                            </>
                        )}
                    </ThemedView>
                }
            </ThemedView>
        </>
    );
};

export default Footer; 

const ls = StyleSheet.create({
    nativeBtn: {
        position: 'absolute',
        bottom: 0,
        width: '100%',
    },
    webBtn: {
        position: screenWidth>450 ?'absolute':'fixed',
        bottom: 0,
        left: 0,
        width: '100%'
    },
    bodyContainer: {
        flex: 1,
        paddingHorizontal: 16,
        paddingVertical: 24,
    }
});